
import html2canvas from 'html2canvas'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Qrcode from 'vux/src/components/qrcode/index.vue'

import { getintegral, getSignlist, operateCredit, getRuleList, getUserAccount, getSignData, getUserinfo } from '@/api/user.js'
import { addPartyCount } from '@/api/jfhl.js'
import defautphoto from '@/assets/timg.jpg'
import iconqc from '@/assets/icon-qianc.png'
import icon1 from '@/assets/user-04.png'
import icon2 from '@/assets/user-05.png'
import icon3 from '@/assets/user-06.png'
import icon4 from '@/assets/user-07.png'
import iconjf from '@/assets/ico-jd.png'
import icongz from '@/assets/ico-gz.png'
import config from '@/config'
import Storage from '@/storage'
import { getNowtDate, getRequest } from '@/libs/utils.js'
export default {
directives: {
TransferDom
},
name: 'sign',
components: {
Group,
Cell,
XButton,
XDialog,
Qrcode
},
data () {
return {
iconjf: iconjf,
icongz: icongz,
tabOne: false,
iconqc: iconqc,
icon1: icon1,
icon2: icon2,
icon3: icon3,
icon4: icon4,
isqd: '',
integral: 0,
allnow: '',
date: getNowtDate(),
owner_type: config.owner_type,
rulelist: [],
defautphoto: defautphoto,
baseUrl: config.baseUrl,
photo: '',
userid: Storage.get('userid'),
currentTime: '',
addIntegral: 0,
addIntegral1: 0, // 一次性
signlist: [],
weeklist: [],
signindats: 0,
showDialog: false,
qrcodeUrl: '',
downImgUrl: ''
}
},
mounted () {
},
created () {







this.getsign()
this.getintegralTotal()
this.getRule()
this.getUserMessage()
},
watch: {
isqd (newVal, oldVal) {
this.isqd = newVal
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
methods: {
getRecord () {
this.$router.push({ path: '/userinfo/signlist' })
},
gohome () {
this.$router.push({ name: 'mallIndex' })
},
getintegralTotal () {
/* 得到用户积分总信息 */
getintegral({
accountid: this.accountid,
owner_type: this.owner_type,
userid: this.userid
}).then(res => {
this.integral = res.returnValue
})
},
getISsign () {
/* 获取签到记录 */
getSignlist({
accountid: this.accountid,
month: this.date.slice(0, 7)
}).then(res => {
let currentdate = this.date
if (res.returnValue && res.returnValue.length > 0) {
this.signlist = res.returnValue
this.getDates(this.date).forEach((item, index) => {
this.signlist.forEach(obj => {
if (new Date(item).getTime() == new Date(obj.searchdate).getTime()) {
this.$set(this.weeklist, index, {
...this.weeklist[index],
signres: obj.signres,
date: item.slice(8, 10)
})
}
})
})
}
})
},
addcount () {
addPartyCount({
accoutid: this.accountid,
credittype: 2
}).then(res => {
})
},
sign () {
/* 添加积分 */
operateCredit({
accountid: this.accountid,
owner_type: this.owner_type
}).then(res => {
if (res.status === 'suc') {
this.addcount()
this.$vux.toast.text('签到成功', 'middle')
this.date = this.date.slice(0, 7)
this.getintegralTotal()
this.getsign()
this.getRule()
} else {
this.$vux.toast.text(res.message, 'middle')
}
})
},



getsign () {
getSignData({
accountid: this.accountid,
owner_type: this.owner_type
}).then(res => {
this.weeklist = []
res.returnValue.rows.forEach(item => {
this.$set(this.weeklist, this.weeklist.length, {
time: item.time.slice(8, 10),
credit: item.credit,
isnow: item.isnow,
istd: item.istd
})
if (item.isnow == 1) {
this.isqd = item.istd
if (item.istd == 1) {
this.addIntegral = item.credit
}
}
})
this.signindats = res.returnValue.signindats

this.getISsign()
})
},
getRule () {
getRuleList({
incometype: 1,
owner_type: this.owner_type,
page: 1,
rows: 20,
userid: this.userid,
accountid: this.accountid
}).then(res => {
this.rulelist = res.returnValue.list
res.returnValue.list.forEach(item => {
console.log(item.remark)
if (item.rulecycle === 5) {
this.addIntegral1 = this.addIntegral1 + item.cycgetcnt
} else {
this.addIntegral = this.addIntegral + item.cycgetcnt
}
})
})
},
getUserMessage () {
getUserAccount({
accountid: this.accountid
}).then(res => {
if (res.status === 'suc') {
this.personObj = res.returnValue
this.photo = res.returnValue.iconimgPATH
}
})
},
getDates (currentTime) { // JS获取当前周从星期一到星期天的日期
var currentDate = new Date(currentTime)
var timesStamp = currentDate.getTime()
var currenDay = currentDate.getDay()
var dates = []
for (var i = 0; i < 7; i++) {
let str = new Date(timesStamp + 24 * 60 * 60 * 1000 * (i - (currenDay + 6) % 7)).toLocaleDateString().replace(/\//g, '-')
let arr = new Array()
arr = str.split('-')
arr.forEach((item, index) => {
if (index > 0 && item.length < 2) {
arr[index] = '0' + item
}
})
str = arr.join('-')
dates.push(str)
}
return dates
},
complete (obj) {
if (obj.rulename.indexOf('邀请') > -1) {

let link = config.baseDeaultUrl + '/?shareid=' + this.accountid
this.qrcodeUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + config.appid + '&redirect_uri=' + link + '&response_type=code&scope=snsapi_base&state=200&connect_redirect=1#wechat_redirect'
this.showDialog = true
setTimeout(() => {
this.shareImg()
}, 500)
} else {
window.location.href = obj.remark
}
},

shareImg () {
html2canvas(this.$refs.imageWrapper, { scrollY: 0 }).then(canvas => {
let dataURL = canvas.toDataURL('image/jpg')
this.downImgUrl = dataURL
})
},
gotojianianhua () {
this.$router.push({ name: 'jianianhuaindex' })
}
},
mounted () {
}
}
